import React, { PureComponent } from 'react'
import Head from "next/head";
import NProgress from "components/NProgress";
import SeoMeta from '/components/seoMeta';
import { duwunCoverLogo } from '/utils/common';

export default class SubscribeUs extends PureComponent {
    render() {
        return (
            <div>
              <Head>
                <title>Subscribe Us</title>
              </Head>
              <SeoMeta 
                  url={`${process.env.BACKEND_URL}/subscribe-us`} 
                  type="article"
                  title='Subscribe-us'
                  description="Subscribe-us"
                  image={duwunCoverLogo}
                  section='Subscribe-us'
                  keywords='Subscribe-us'
                />        
              <NProgress />
            </div>
          );
    }
}
